import Connection from './Connection.js'
import Session from './Session'
import { jsonRpc } from './JsonRpc'
import { p2pStrategy, sfuStrategy } from './strategies'

class Mediator {
  constructor() {
    this.strategies = {
      p2p: p2pStrategy,
      sfu: sfuStrategy,
    }
    this.standbyConnection = null
    this.connections = {
      p2p: new Connection(p2pStrategy),
      sfu: new Connection(sfuStrategy),
    }
    jsonRpc.on('con:strategy', this.handleStrategyChange)
    this.strategy = undefined
  }

  get connection() {
    return this.connections[this.strategy]
  }

  createSession(endpoint, appType, key, callId) {
    this.session = new Session(this)
    return this.session.getApiSessionInfo(endpoint, appType, key, callId)
  }

  call = newStrategy => {
    const oldStrategy = this.strategy
    this.strategy = newStrategy
    if (newStrategy === oldStrategy) {
      return
    }
    const currentConnection = this.connections[oldStrategy]
    if (currentConnection) {
      currentConnection.destroy()
    }
    const newConnection = this.connections[newStrategy]
    if (newConnection) {
      newConnection.initialize()
    }
  }

  changeStrategy = () => {
    if (this.standbyConnection) {
      const standby = this.standbyConnection
      this.connection.destroy()
      setTimeout(() => {
        this.connection = standby
        this.connection.release()
        delete this.standbyConnection
      }, 1000)
    }
  }

  send(message, callback) {
    jsonRpc.send(message, callback)
  }

  async sendAndWait(message) {
    return await jsonRpc.sendAndWait(message)
  }

  startRecording = conference => {
    this.connection?.startRecording(conference)
  }

  stopRecording = () => {
    this.connection?.stopRecording()
  }

  broadcast = data => {
    this.connection?.broadcast(data)
  }

  destroy = () => {
    this.connection?.destroy()
  }

  // Websocket reconnect only: also forget the strategy, so the con:strategy the server sends after the
  // re-join (usually the same value) runs call() and initializes the connection again
  reset = () => {
    const connection = this.connection
    this.strategy = undefined
    connection?.destroy()
  }
  handleStrategyChange = (event) => {
    const { strategy } = event.detail
    this.call(strategy.toLowerCase())
  }
}

const mediator = new Mediator()
export { mediator }
